import { SVGProps } from "react";

export default function ThumbsUpReactionIcon(
  props: SVGProps<SVGSVGElement> & { accent?: string },
) {
  const {
    height = 20,
    width = 20,
    stroke = "#757575",
    accent = "#AFAFAF",
    ...rest
  } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M6.23438 15.292L8.81771 17.292C9.15104 17.6254 9.90104 17.792 10.401 17.792H13.5677C14.5677 17.792 15.651 17.042 15.901 16.042L17.901 9.95871C18.3177 8.79205 17.5677 7.79205 16.3177 7.79205H12.9844C12.4844 7.79205 12.0677 7.37538 12.151 6.79205L12.5677 4.12538C12.7344 3.37538 12.2344 2.54205 11.4844 2.29205C10.8177 2.04205 9.98437 2.37538 9.65104 2.87538L6.23438 7.95871"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M1.98438 15.292V7.12533C1.98438 5.95866 2.48438 5.54199 3.65104 5.54199H4.48437C5.65104 5.54199 6.15104 5.95866 6.15104 7.12533V15.292C6.15104 16.4587 5.65104 16.8753 4.48437 16.8753H3.65104C2.48438 16.8753 1.98438 16.4587 1.98438 15.292Z"
        stroke={accent}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
